export const environment = {
  loginUrl: process.env.SIGNIN_TRAVELERS_URL,
  registrationUrl: process.env.SELFSERVICE_ROUTE + '/registration/#/select-user-id',
  travelersLegalUrl: process.env.TRAVELERS_URL + '/w3c/legal/',
  travelersPrivacyUrl: process.env.TRAVELERS_URL + '/privacy-statements/',
  travelersAccessibilityUrl: process.env.TRAVELERS_URL + '/about-travelers/accessibility'
};
